const _ = "_sm_fevco_1", s = "_md_fevco_5", o = "_lg_fevco_9", c = "_xl_fevco_13", l = {
  sm: _,
  md: s,
  lg: o,
  xl: c
};
export {
  l as default,
  o as lg,
  s as md,
  _ as sm,
  c as xl
};
//# sourceMappingURL=AccordionGroup.module.scss.js.map
